import { Button } from '@ophelos/ui/components/button';
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle } from '@ophelos/ui/components/empty';
import { Scroll } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { useTranslation } from '@/hooks/useTranslation';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Layout showFooter={false}>
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="icon" className="mt-6 mb-8">
                <div className="p-4.5 border  border-border-light/60 rounded-[3rem]">
                  <div className="p-4 border border-border-light/90 rounded-4xl">
                    <div className="p-3 border rounded-2xl">
                      <Scroll />
                    </div>
                  </div>
                </div>
              </EmptyMedia>
              <EmptyTitle>{t('notFound.title')}</EmptyTitle>
              <Button variant="default" asChild className="mt-4">
                <a onClick={() => navigate('/login')}>{t('notFound.backHome')}</a>
              </Button>
            </EmptyHeader>
          </Empty>
        </div>
      </div>
    </Layout>
  );
}
